import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/tariffs/";
const url = apiUrl + endPoint;

export async function getTariffs() {
  return await http.get(url);
}

export async function getTariffsForCustomer(customerId) {
  return await http.get(url + "customer/" + customerId);
}

export async function getTariffById(tariffId) {
  return await http.get(url + tariffId);
}

export async function changePublishedStatus(tariffId, status) {
  return await http.put(url + "changedPublishedStatus/" + tariffId, { isPublished: status });
}

export async function addTariff(tariff) {
  return await http.post(url, tariff);
}

export async function updateTariff(tariff) {
  const payload = { ...tariff };
  const oltId = payload._id;
  delete payload._id;
  return await http.put(url + oltId, payload);
}
